import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmFromCurrentUrl } from '../../shared/utils/utmAttribution';

/** Persists first-touch and last-touch UTMs from the URL on every route change. */
const UtmCapture: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    captureUtmFromCurrentUrl();
  }, [location.pathname, location.search]);

  return null;
};

export default UtmCapture;
